import {
  Component,
  EventEmitter,
  Input,
  Output
}                           from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  template: require('./push-pop.component.html')
})
export class PushPopComponent {
  @Input() popTitle  : string  = this.translateService.instant('GENERAL_SPACE.TITLE.REMOVE');
  @Input() pushTitle : string  = this.translateService.instant('GENERAL_SPACE.FIELD.ADD');
  @Input() record    : any;

  @Output() onPop : EventEmitter<any> = new EventEmitter();
  @Output() onPush: EventEmitter<any> = new EventEmitter();

  constructor (
    private translateService: TranslateService
  ) {}

  pop () : void {
    this.record.added = false;

    this.onPop.emit(this.record);
  }

  push () : void {
    this.record.added = true;

    this.onPush.emit(this.record);
  }
}
